import React, { useEffect } from "react";
import './styles.css'
import { PaperAdd } from "solar-icon-set/notes";
import { Colors } from "../../../utils/constants/colors";
import { CloseCircle } from "solar-icon-set/essentionalui";
import { FaRegImage } from "react-icons/fa";
import { useNavigate, useSearchParams } from "react-router-dom";
import { LuTextSearch } from "react-icons/lu";
import BottomSheet from "../../../components/bottomsheet";
import { useAxios } from "../../../hooks/useAxios";
import { ApiCollection } from "../../../config/envConfig";
import SpinnerLoader from "../../../components/loader";
import DataRenderer from "../../../components/render";
import { ExamSectionEnum } from "../../../utils/enums/exam";
import Modal from "../../../components/modal";
import LoadingModal from "../../../components/loadingModal";
import Compressor from "compressorjs";
import SubjectHeader from "../../../components/subjectHeader";


export default function TestViewScreen() {


    useEffect(() => {
        getQuestions();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const navigate = useNavigate();
    const axios = useAxios();

    const [searchParams] = useSearchParams()

    const examId = searchParams.get('examId');
    const title = searchParams.get('title');

    const getQuestions = async () => {
        setIsLoading(true);
        await axios.get(`${ApiCollection.subject.getQuestions}?exam_id=${examId}`)
            .then((response) => {
                // console.log(response.data.questions);
                setQuestions(response.data.questions);
                setIsLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching questions:', error);
                setIsLoading(false);
            });
    }


    const [selectedQuestion, setSelectedQuestion] = React.useState(0);
    const [answerMode, setAnswerMode] = React.useState<'text' | 'upload'>('upload');
    const [answerText, setAnswerText] = React.useState('');

    const [showBottomSheet, setShowBottomSheet] = React.useState(false);

    const [sheets, setSheets] = React.useState<File[]>([]);
    const [isLoading, setIsLoading] = React.useState(false);

    const [questions, setQuestions] = React.useState<any>([]);

    const [showSubmitConfirmation, setShowSubmitConfirmation] = React.useState(false);

    const [isUploading, setIsUploading] = React.useState(false);


    const onSaveNext = async () => {

        const isMCQ = questions[selectedQuestion].question_type === ExamSectionEnum.MCQ;

        if (isMCQ === false) {
            if (answerMode === 'upload' && sheets.length === 0) {
                alert('Please upload your answer sheet');
                return
            }

            if (answerMode === 'text' && answerText === '') {
                alert('Please enter your answer');
                return
            }
        } else {
            if (answerText === '') {
                alert('Please select an option');
                return
            }
        }




        setIsUploading(true);
        let formData = new FormData();
        formData.append('exam_id', examId || '');
        formData.append('question_id', questions[selectedQuestion].question_id);

        if (isMCQ) {
            formData.append('student_answer', answerText);
        } else {
            if (answerMode === 'text') {
                formData.append('student_answer', answerText);
            } else {
                sheets.forEach((sheet, index) => {
                    formData.append('student_answer_image', sheet);
                });
            }
        }


        await axios.post(ApiCollection.subject.uploadAnswer, formData, {
            headers: {
                'Content-Type': 'multipart/form-data', // Important for file uploads
            }
        })
            .then((response) => {


                let currentQuestions = questions.slice(0);
                currentQuestions[selectedQuestion].is_submitted = true;
                setQuestions(currentQuestions);
                setAnswerText('');
                setAnswerMode('upload');
                setSheets([]);

                setIsUploading(false);
                if (selectedQuestion !== questions.length - 1) {
                    setSelectedQuestion(selectedQuestion + 1);
                }
            })
            .catch((error) => {
                setIsUploading(false);
                alert(error?.response?.data?.detail || 'Error saving answer');
                console.error('Error saving answer:', error.response.data.detail);
            })



    }

    const onSubmit = () => {

        const isMCQ = questions[selectedQuestion].question_type === ExamSectionEnum.MCQ;

        if (isMCQ) {
            if (answerText !== '') {
                onSaveNext()
            }
        } else {
            if (answerMode === 'text' && answerText !== '') {
                onSaveNext()
            } else if (answerMode === 'upload' && sheets.length > 0) {
                onSaveNext()
            }

        }
        setShowSubmitConfirmation(true);
    }

    const onSubmitExam = async () => {


        setIsUploading(true);
        await axios.post(ApiCollection.subject.submitTest, { exam_id: examId })
            .then((response) => {
                const subjectId = response.data.subject_id;
                setIsUploading(false);
                navigate(`/test/end?examId=${examId}&title=${title}&subjectId=${subjectId}`);
            })
            .catch((error) => {
                setIsUploading(false);
                alert('Error submitting exam');
                console.error('Error submitting exam:', error);
            })
    }

    const onBack = () => {
        if (selectedQuestion > 0) {
            setSelectedQuestion(selectedQuestion - 1);
            setAnswerText('');
            setSheets([]);
        }
    }

    const onSkip = () => {
        setSelectedQuestion(selectedQuestion + 1);
        setAnswerText('');
        setSheets([]);
    }

    const handleFileSelect = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = Array.from(e.target.files || []);
        if (files.length === 0) return;

        const compressImage = (file: File): Promise<File> => {
            return new Promise((resolve, reject) => {
                new Compressor(file, {
                    quality: 0.6, // Adjust quality as needed (0.6 = 60% quality)
                    maxWidth: 1920, // Max width of the output image
                    maxHeight: 1920, // Max height of the output image
                    success(result) {
                        // Create a new File object from the compressed Blob
                        const compressedFile = new File([result], file.name, {
                            type: 'image/jpeg',
                            lastModified: Date.now(),
                        });
                        resolve(compressedFile);
                    },
                    error(err) {
                        console.error('Image compression failed:', err);
                        reject(err);
                    },
                });
            });
        };

        try {
            const compressedFiles = await Promise.all(files.map(file => compressImage(file)));
            setSheets(prevSheets => [...prevSheets, ...compressedFiles]);
        } catch (error) {
            console.error('Error processing images:', error);
            alert('Error processing images. Please try again.');
        }
    };



    if (isLoading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', height: '100%', width: '100%' }}>
                <SpinnerLoader />
                <h2 style={{ marginTop: 10, fontSize: 20 }}>
                    Loading...
                </h2>
            </div>
        )

    }

    if (questions.length === 0) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', height: '100%', width: '100%' }}>
                <h2 style={{ marginTop: 10, fontSize: 20 }}>
                    No questions found
                </h2>
            </div>
        )
    }

    return (
        <div className="test_view_screen">

            <LoadingModal
                isOpen={isUploading}
                message="Submitting answer..."
            />

            <div className="test_wrapper">

                <SubjectHeader
                    title={''}
                    description=''
                    className="test"
                />



                {
                    questions[selectedQuestion] &&
                    <div className="subject_view_question_holder">
                        <div className="subject_view_head_holder">
                            <h3>Question {questions[selectedQuestion].question_number} / {questions.length}</h3>

                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <span style={{ color: Colors.primary, fontWeight: 'bold' }}>( {questions[selectedQuestion].marks} mark )</span>

                                <LuTextSearch size={22}
                                    onClick={() => setShowBottomSheet(true)}
                                    style={{ cursor: 'pointer', marginLeft: 10 }}
                                />
                            </div>
                        </div>
                        <p>
                            <DataRenderer
                                type='mathpix'
                                text={questions[selectedQuestion].question_text || ''}
                            />

                            <div className="question_image_container">
                                {
                                    questions[selectedQuestion].question_image &&
                                    questions[selectedQuestion].question_image.map((img: any) => (
                                        <div className="question_image_holder">
                                            <img
                                                src={img.url}
                                                alt="question"
                                                style={{ height: '100%', objectFit: 'contain', marginTop: 15 }}
                                            />
                                        </div>
                                    ))

                                }
                            </div>
                        </p>
                    </div>
                }



                {
                    questions[selectedQuestion].is_submitted === false ?
                        <div className="subject_view_question_holder answer">
                            {
                                questions[selectedQuestion].question_type === ExamSectionEnum.MCQ ?
                                    <h3>Select Option</h3>
                                    :
                                    answerMode === 'upload' ?
                                        <div className="subject_view_head_holder">
                                            <h3>Upload Answer Sheet(s)</h3>

                                            <button className="subject_view_head_holder_button" onClick={() => setAnswerMode('text')}>
                                                <PaperAdd size={22} color={Colors.primary} />
                                                {/* <span>Text</span> */}
                                            </button>
                                        </div>
                                        :
                                        <div className="subject_view_head_holder">
                                            <h3>Enter Answer</h3>

                                            <button className="subject_view_head_holder_button" onClick={() => setAnswerMode('upload')}>
                                                <FaRegImage size={22} color={Colors.primary} />

                                                {/* <span>Upload</span> */}
                                            </button>
                                        </div>
                            }

                            {
                                questions[selectedQuestion].question_type === ExamSectionEnum.MCQ ? (
                                    questions[selectedQuestion].options.length > 0 &&
                                    <div className="subject_view_option_holder">
                                        {
                                            questions[selectedQuestion].options.map((option: any, index: number) => (
                                                <div className={`subject_view_option ${answerText === option.option_text ? 'selected' : ''}`} onClick={() => setAnswerText(option.option_text)}>
                                                    {/* <input type="radio" name="option" id={`option_${option.option_text}`} /> */}
                                                    <div className={`radio ${answerText === option.option_text ? 'selected' : ''}`}>
                                                        {
                                                            answerText === option.option_text &&
                                                            <div className="radio_inner" />
                                                        }

                                                    </div>
                                                    <div style={{ width: '100%' }}>
                                                        <label>
                                                            <DataRenderer
                                                                type='mathpix'
                                                                text={option.option_text || ''}
                                                            />
                                                        </label>
                                                        <div className="question_image_container">
                                                            {
                                                                option.option_image_url &&

                                                                option.option_image_url.map((img: any) => (
                                                                    <div className="question_image_holder">
                                                                        <img
                                                                            src={img.url}
                                                                            alt="question"
                                                                            style={{ height: '100%', objectFit: 'contain', marginTop: 15 }}
                                                                        />
                                                                    </div>
                                                                ))

                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                )
                                    :
                                    answerMode === 'upload' ?
                                        <div className="upload_answer_screen_content">
                                            {
                                                sheets.length > 0 &&
                                                sheets.map((sheet, index) => (
                                                    <div className="answer_sheet_preview" key={index}>
                                                        <img src={URL.createObjectURL(sheet)} alt="answer sheet" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                                                        {/* <span>Page {index+1}</span> */}
                                                        <div className="answer_sheet_preview_overlay"
                                                            onClick={() => {
                                                                setSheets(sheets.filter((_, i) => i !== index));
                                                            }} >
                                                            <CloseCircle size={20} color={'white'} iconStyle="Bold" />
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                            <div className="upload_answer_sheet_button">
                                                <label className="upload-button">
                                                    <input
                                                        type="file"
                                                        accept=".png, .jpg, .jpeg"
                                                        multiple
                                                        onChange={handleFileSelect}
                                                    />
                                                    <div className="upload-content">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                                                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                                            <polyline points="17 8 12 3 7 8" />
                                                            <line x1="12" y1="3" x2="12" y2="15" />
                                                        </svg>
                                                        <span>Upload</span>
                                                    </div>
                                                </label>
                                            </div>
                                        </div>
                                        :
                                        <div className="subject_view_text_answer">
                                            <textarea placeholder="Type your answer here"
                                                value={answerText}
                                                onChange={(e) => setAnswerText(e.target.value)}
                                            />
                                        </div>
                            }

                        </div>
                        :
                        <div className="subject_view_question_holder answer">
                            <div className="subject_view_head_holder">
                                <h3 style={{ color: Colors.primary }}>Submittion</h3>

                            </div>
                            <p style={{ color: 'gray', fontSize: 14 }}>
                                Your answer has been submitted successfully.
                            </p>
                        </div>
                }


                <BottomSheet
                    isOpen={showBottomSheet}
                    onClose={() => setShowBottomSheet(false)}
                    heading="Select Question"
                >
                    <div className="bottom_sheet_content">
                        <div className="question_list_header">
                            <div className="question_list_header_item">
                                <div className="question_list_box dummy selected">
                                    <span>1</span>
                                </div>
                                <span>Selected</span>
                            </div>

                            <div className="question_list_header_item">
                                <div className="question_list_box dummy unattempted">
                                    <span>1</span>
                                </div>
                                <span>Unattempted</span>
                            </div>

                            <div className="question_list_header_item">
                                <div className="question_list_box dummy submitted">
                                    <span>1</span>
                                </div>
                                <span>Submitted</span>
                            </div>
                        </div>

                        <div className="question_list">
                            {
                                questions.map((question: any, index: any) => (
                                    <div
                                        onClick={() => {
                                            setSelectedQuestion(index);
                                            setShowBottomSheet(false)
                                        }}
                                        className={`question_list_box ${question.is_submitted ? 'submitted ' : ' '} ${selectedQuestion === (index) ? 'selected' : ''}`}>
                                        <span>{question.question_number}</span>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </BottomSheet>

                <div className="new_footer">
                    {
                        selectedQuestion > 0 ?
                            <button className="primary_btn outline subject_view_footer_button" onClick={onBack}>
                                <span>Back</span>
                            </button>
                            :
                            <button className="primary_btn outline subject_view_footer_button" style={{ backgroundColor: 'gray', cursor: 'not-allowed', opacity: 0 }} disabled>
                                <span>Back</span>
                            </button>
                    }

                    {
                        selectedQuestion === questions.length - 1 ?
                            null
                            :
                            <button className="primary_btn subject_view_footer_button no_style" onClick={onSkip}>
                                <span>SKIP</span>
                            </button>
                    }

                    {
                        selectedQuestion === questions.length - 1 ?
                            <button className="primary_btn subject_view_footer_button submit" onClick={onSubmit}>
                                <span>Save & Submit</span>
                            </button>
                            :
                            questions[selectedQuestion].is_submitted ?
                                <button className="primary_btn subject_view_footer_button" onClick={onSkip}>
                                    <span>Next</span>
                                </button>
                                :

                                <button
                                    disabled={
                                        (answerMode === 'text' && answerText === '') ||
                                        (questions[selectedQuestion].question_type !== ExamSectionEnum.MCQ && answerMode === 'upload' && sheets.length === 0)}
                                    className="primary_btn subject_view_footer_button save" onClick={onSaveNext}>
                                    <span>Save & Next</span>
                                </button>
                    }
                </div>
                {
                    showSubmitConfirmation &&
                    <Modal
                        style={{ width: '50%', height: '40%', }}
                        onClose={() => setShowSubmitConfirmation(false)}
                    >
                        <div className="submit_confirmation">
                            <h3>Are you sure you want to submit this exam ?</h3>
                            <p>
                                You can't change your answers once you submit the exam.
                            </p>
                            <button
                                className="primary_btn subject_view_footer_button submit"
                                style={{ width: '40%', marginTop: 20 }}
                                onClick={onSubmitExam}
                            >
                                <span>Submit & Complete Exam</span>
                            </button>
                        </div>

                    </Modal>
                }
            </div>
        </div>
    )
}